/**
 * The Tickets routes' addresses (028 FR-028-045), in one module the client page, the sidebar and the
 * portal's own screens share without loading each other's chunks.
 */
export function ticketsPath(ws: string, accountId: string): string {
  return `/${ws}/tickets/${accountId}`;
}

/** One ticket's own route under its client's Tickets (028 FR-028-045), which its notices open. */
export function ticketPath(ws: string, accountId: string, requestId: string): string {
  return `/${ws}/tickets/${accountId}/${requestId}`;
}

/** A client's conversations, the Messages list under its Tickets (028 FR-028-045 as amended 2026-10-21). */
export function threadsPath(ws: string, accountId: string): string {
  return `/${ws}/tickets/${accountId}/threads`;
}

/** One standalone thread's own route under its client's Tickets (028 FR-028-045), which its notices open. */
export function threadPath(ws: string, accountId: string, threadId: string): string {
  return `/${ws}/tickets/${accountId}/threads/${threadId}`;
}
